import { css } from '@mui/styled-engine'

import type { HAVDesignTokensInterface } from '../interfaces'
import { havDefault02Text } from './Texts'

const havPrimaryButton = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  color: ${HAVDesignTokens.palette.neutral.white};
  text-transform: ${HAVDesignTokens.typography.text.decoration.uppercase};
  ${havDefault02Text(HAVDesignTokens)};

  border-radius: ${HAVDesignTokens.shape.border.radius.small};
  padding: ${HAVDesignTokens.spacing.padding.height.small};

  :disabled {
    opacity: ${HAVDesignTokens.shape.opacity.disabled};
  }
`

const havBigPrimaryButton = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  padding: ${HAVDesignTokens.spacing.padding.height.medium};
`

const havGhostButton = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  background: none;
  border: ${HAVDesignTokens.shape.border.outline.thin};
`

const havIconButton = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  color: ${HAVDesignTokens.palette.main.primary};
  text-transform: none;

  svg {
    font-size: ${HAVDesignTokens.typography.font.size.small};
  }

  background: ${HAVDesignTokens.palette.neutral.white};
`

const havTextButton = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  color: ${HAVDesignTokens.palette.main.primary};
  font-size: ${HAVDesignTokens.typography.font.size.x.small};
  font-family: ${HAVDesignTokens.typography.font.weight.medium};
  line-height: ${HAVDesignTokens.typography.lineHeight};

  :hover,
  :focus {
    color: ${HAVDesignTokens.palette.hover.primary};
  }
`

export { havBigPrimaryButton, havGhostButton, havIconButton, havPrimaryButton, havTextButton }
